


























import {Prop, Watch} from "vue-property-decorator";
import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Timeout, WatchObjectProperties} from '@/shared/decorator';

import storeBoisType, {BoisTypeFilter} from '@/stores/modules/boisType';

import TrueFalseMultiSelect from '@/components/Input/TrueFalseMultiSelect.vue';

@Component({
	components: {
		TrueFalseMultiSelect,
	}
})
export default class CrudBoisTypeFilter extends Vue {
	
	@Prop({ type: Boolean, default: false}) reduce;
	
	@Stored(() => storeBoisType) private page!: number;
	@Stored(() => storeBoisType) private filters!: BoisTypeFilter;
	
	@WatchObjectProperties('filters', BoisTypeFilter)
	@Timeout()
	private filtersWatcher(): void {
		this.page = 0;
		storeBoisType.dispatch('getC', { filters: true });
	}
	
}
